<template>
  <ImplementationChecklist
    :visible="showSidebar"
    @hide="closeImplementationChecklist"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import ImplementationChecklist from './ImplementationChecklist.vue';

const onboardingModule = 'OnboardingModule';

export default {
  name: 'OnboardingSidebar',

  components: {
    ImplementationChecklist,
  },

  computed: {
    ...mapGetters(onboardingModule, {
      implementationChecklistDismissed: 'getImplementationChecklistDismissed',
    }),

    showSidebar() {
      const { hideImplementationChecklist } = this.$route.meta;

      return !hideImplementationChecklist && !this.implementationChecklistDismissed;
    },
  },

  methods: {
    ...mapActions(onboardingModule, [
      'updateImplementationChecklistDismissed',
    ]),

    closeImplementationChecklist() {
      this.updateImplementationChecklistDismissed(true);
    },

    openImplementationChecklist() {
      this.updateImplementationChecklistDismissed(false);
    },
  },
};
</script>
